/* eslint-disable max-len */
import React, { useId } from 'react'

import { string } from 'prop-types'

// ui-library#TBD - the design's bullet glyph is a single gradient-filled sparkle.
// Triangle's AIGeneratedGradientFilled draws the same sparkle plus two satellites,
// and no single-sparkle variant exists yet, so the path is staged here until the
// upstream icon lands.
function SparkleIcon({ className = '' }) {
  // React's useId emits colons, which are valid in an HTML id but awkward inside
  // the url(#...) reference the fill needs.
  const gradientId = `upgrade-notice-sparkle-${useId().replace(/[^a-zA-Z0-9_-]/g, '')}`

  return (
    <svg
      className={className}
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      aria-hidden="true"
      focusable="false"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 3.00049C9.31361 3.00053 9.59409 3.19572 9.70312 3.48975L10.0908 4.53564L10.4346 5.44873C10.7313 6.20942 10.9101 6.55513 11.1777 6.82275C11.5347 7.17954 12.0299 7.37902 13.4648 7.90967L14.5107 8.29736C14.8047 8.40647 15 8.68692 15 9.00049C14.9998 9.31394 14.8046 9.59463 14.5107 9.70361L13.4648 10.0913L13.4609 10.0923C12.028 10.6222 11.5343 10.8221 11.1787 11.1782C10.9113 11.4461 10.7316 11.792 10.4346 12.5532L10.0908 13.4653L9.70312 14.5112C9.59399 14.805 9.31347 15.0004 9 15.0005C8.68651 15.0005 8.40604 14.805 8.29688 14.5112L7.90918 13.4653L7.9082 13.4614C7.37844 12.0289 7.17817 11.5348 6.82227 11.1792C6.55436 10.9117 6.20851 10.7321 5.44727 10.4351L4.53516 10.0913L3.48926 9.70361C3.19536 9.59463 3.0002 9.31394 3 9.00049C3 8.68686 3.19525 8.40643 3.48926 8.29736L4.53516 7.90967L5.44824 7.56592C6.20906 7.2692 6.55461 7.09032 6.82227 6.82275C7.1792 6.46582 7.37849 5.97068 7.90918 4.53564L8.29688 3.48975L8.3457 3.38428C8.47675 3.14998 8.72559 3.00049 9 3.00049Z"
        fill={`url(#${gradientId})`}
      />
      <defs>
        <linearGradient id={gradientId} x1="3" y1="9" x2="15" y2="9" gradientUnits="userSpaceOnUse">
          <stop stopColor="#19BCC9" />
          <stop offset="1" stopColor="#A68DFE" />
        </linearGradient>
      </defs>
    </svg>
  )
}

SparkleIcon.propTypes = {
  className: string,
}

export default SparkleIcon
